module.exports = {"360925100":"双溪镇","360925101":"仁首镇","360925102":"宝峰镇","360925103":"高湖镇","360925104":"璪都镇","360925105":"官庄镇","360925200":"香田乡","360925201":"水口乡","360925202":"中源乡","360925205":"三爪仑乡","360925206":"雷公尖乡","360925400":"靖安县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360925.json
// module id = 1436
// module chunks = 0